import React from "react";

const BS5_GridSmall = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridSmall Component</h2>
      <p>This is the BS5_GridSmall component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridSmall;
